import { createContext } from "react";
import { IThemeConfig, ThemeName } from "./constants";

export interface ThemePaths {
  [key: string]: string;
}

export interface ThemeContextType {
  themeSetting: ThemeName | null;
  appliedTheme: ThemeName | null;
  switchToTheme: (newTheme: ThemeName) => void;
  availableThemes: IThemeConfig[];
}

export const ThemeContext = createContext<ThemeContextType>({
  themeSetting: null,
  appliedTheme: null,
  switchToTheme: () => {},
  availableThemes: [],
} as ThemeContextType);
